import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { authenticatedUser, authToken, loading } = useAuth();

  if (loading) {
    // Mostrar un indicador de carga mientras se verifica la autenticación
    return <div>Loading...</div>;
  }

  if (!authToken && !authenticatedUser) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;
